<template>
  <div class="carousel">
    <mt-swipe :auto="4000" >
      <mt-swipe-item class="slide1" v-for="(item, key) in list" :key="key">
          <img :src="item.icon" @click="clickOpen(item)">
      </mt-swipe-item>
    </mt-swipe>
  </div>
</template>

<script>
import { cblockItem } from '@/api/app'

export default {
  name: 'ScrollBar',
  props: ['list'],
  data () {
    return {
    }
  },
  methods: {
      clickOpen: function(item){
        cblockItem(item, this)
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mint-swipe {
  height: 40vw;
  color: #fff;
  font-size: 30px;
  text-align: center;
}
.mint-swipe-item {
  line-height: 40vw;
}
.carousel img{
    max-height: 100%;
    min-width: 100%;
}
</style>
